import { BaseBus } from "./BaseBus";
import { DateFunctions } from '../static/date-functions';
import { CommonFunctions } from "../static/common-functions";

 export class DispatchVendorCreditBus extends BaseBus
 { 
     constructor(busObj: BaseBus = null) {
         super(busObj);
         this.usrDt = DateFunctions.getDate(this.usrDt);
     }
     dispatchId: any;
     invNum: string;
     invDesc: string;
     ordNum: string;
     qnty: number;
     cst: number;
     usr: string;
     usrDt: Date;
     get amount(): number {
         return (CommonFunctions.hasNumberValue(this.qnty) && CommonFunctions.hasNumberValue(this.cst) ? this.qnty * this.cst : 0);
     }
 }
